export default __webpack_public_path__ + "static/media/kitchen2-1920w.a586e3ad.avif";